import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRouteJoin = '/operation-auxiliary/join-sale-note';

@Injectable({
  providedIn: 'root'
})
export class SaleNoteJoinDocumentService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRouteJoin);
  }
}
